
<!-- HEADER COMPONENT -->
<header class='tw-header'>
    <div class="tw-header__ctn-logo">
        <span title='Logo Twona' class='tw-header__logo'>
          <figure class='tw-header__fig'>
             <img src='assets/logo_twona.svg' alt='Logo Twona' />
          </figure>
        </span>
    </div>
    <nav class="tw-header__main-nav" >
      <ul class="tw-tabs" *ngIf="session != null && permissions != null">
          <li class="tw-header-button tw-hb-dashboard" *ngIf="permissions.access_global_dashboard"
            [ngClass]="{'tw-header-active-button': pageMatch() == 'dashboard'}" (click)="navigateToSkipLocation('dashboard')">Dashboard</li>
          <li class="tw-header-button tw-hb-approvals" *ngIf="permissions.access_global_approvals"
            [ngClass]="{'tw-header-active-button': pageMatch() == 'approvals'}" (click)="navigateTo('approvals/outstanding')">Approvals</li>
          <li class="tw-header-button tw-hb-library" *ngIf="permissions.access_global_library" 
            [ngClass]="{'tw-header-active-button': pageMatch() == 'library'}" (click)="navigateTo('library')">Library</li>
          <li class="tw-header-button tw-hb-xray " *ngIf="permissions.access_global_xray" 
            [ngClass]="{'tw-header-active-button': pageMatch() == 'xray'}" (click)="navigateTo('p/apollo')">X-Ray</li>
          <li class="tw-header-button tw-hb-ai" *ngIf="permissions.access_kpi_assistant_feature" 
            [ngClass]="{'tw-header-active-button': pageMatch() == 'ai'}" (click)="navigateTo('ai')">AI</li>
      </ul>
    </nav>
    <div class='tw-header__info-user'>
    <core-helpers-navigation-header-menu *ngIf="session != null" [session]="session" (newOrganization)="changeOrg($event)">
    </core-helpers-navigation-header-menu>
    </div>
</header>
<!-- END HEADER COMPONENT  -->
